export class TelemetryLogger {
    public static errorMessage = (error: string) => {
        console.error(error);

        const { appInsights } = window as any;

        appInsights?.trackException(new Error(error));
    };

    public static error = (error: unknown) => {
        console.error(error);

        const { appInsights } = window as any;

        appInsights?.trackException(new Error(`${error}`));
    };
}
